import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigEntities, JSONItems } from 'src/app/core/models/config-entities';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { NavigationService } from '../../../../core/services/navigation.service';
import { Subscription, interval } from 'rxjs';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { SubEntities } from 'src/app/core/models/globals';

@Component({
  selector: 'app-configurator-summary',
  templateUrl: './configurator-summary.component.html',
  styleUrls: ['./configurator-summary.component.scss'],
})
export class ConfiguratorSummaryComponent implements OnInit {
  toShow: boolean;
  configEntities: ConfigEntities[]
  HAInfoSub$: Subscription;
  hAJsonItems: JSONItems[] = [];
  currentHost: string | null;
  haErrorMessage: string | null = "Fetching HA status..."
  showHA: boolean = false;

  constructor(
    private router: Router,
    private configEntityService: ConfigEntityService,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private spinner: NgxSpinnerService,
    private syncConfig: SyncConfigService,
    private authenticationService: AuthenticationService
    ) { }

  ngOnInit(): void {
    this.toShow = false;
    this.navService.sendChildData(SubEntities.ConfiguratorOverview)
    this.navService.sendLeftPanelIndex(0);
    this.spinner.show();
    this.configEntityService.getAllConfigEntities().subscribe(
      (data) => {
        this.configEntities = <ConfigEntities[]>(JSON.parse(JSON.stringify(data)));
        this.arrangeArray();
        this.sortEntitiesAlphabetically(); 
        this.toShow = true;
        this.spinner.hide()
      }
    );
    this.checkHAStatus();
    this.HAInfoSub$ = interval(this.syncConfig.config.header.HAInterval).subscribe(() => {
      if (this.authenticationService.loggedIn()) this.checkHAStatus();
    });
  }

  sortEntitiesAlphabetically() {
    this.configEntities.sort((a, b) => {
      if (a.name < b.name) {
        return -1; 
      } else if (a.name > b.name) {
        return 1; 
      } else {
        return 0;
      }
    });
  }

  arrangeArray(){
    let length = this.configEntities.length -1
    let lastIndex = this.configEntities[length];
    this.configEntities.unshift(lastIndex)
    this.configEntities.pop();
  }

  redirectTo(name: string, idx: number) {
    this.navService.sendLeftPanelIndex(idx + 1);
    this.configEntityService.sendActiveEntity(name)
    this.navService.sendChildData(name)
    this.router.navigate(['../' + name], { relativeTo: this.route });
  }

  showHAInfo() {
    this.showHA = !this.showHA;
  }

  checkHAStatus() {
    this.configEntityService.getHAStatus().subscribe({
      next: (data: any) => {
        if (data && data.result.length > 0) {
          this.hAJsonItems = JSON.parse(JSON.stringify(data.result));
          if (!data?.useHA) {
            this.HAInfoSub$.unsubscribe();
            this.haErrorMessage = "HA is not enabled";
          } else {
            this.currentHost = data?.currentHost.toLowerCase();
          }
        }
      },
      error: error => {
        this.hAJsonItems = [];
        this.haErrorMessage = "Error fetching HA status";
      },
    });
  }

  isCurrentHost(mode: string): boolean {
    return (
      (this.currentHost.toLowerCase() === 'primaryhost' && mode === this.hAJsonItems[0]?.mode) ||
      (this.currentHost.toLowerCase() === 'secondaryhost' && mode === this.hAJsonItems[1]?.mode)
    );
  }

  getStatusClass(status: string): string {
    return status.toLowerCase() === 'active' ? 'status-active' : 'status-inactive';
  }
}
